<template>
    <div class="d-flex flex-column">
        <div class="economicTitle mt-1">Estado Ecónomico</div>

        <div class="px-1">
            <b-form>
                <div class="d-flex align-items-center justify-content-center w-100">
                    <b-form-group>
                        <h5>Rango de Fechas</h5>
                        <flat-pickr v-model="rangeDate" class="form-control" :config="{ mode: 'range' }" />
                    </b-form-group>
                </div>
                <div style="font-weight: 600;font-size: 18px;">
                    <div class="d-flex justify-content-between">
                        <div>Indicador Económico</div>
                        <div>Resultado</div>
                    </div>
                </div>

                <blockquote class="blockquote mb-0"></blockquote>
                <div class="d-flex justify-content-between mt-2">
                    <div> Ingresos:</div>
                    <div> 75000032</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div> Gastos:</div>
                    <div> 652000</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div> Ingreso por animal:</div>
                    <div> 35000</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div> Ganancia de Peso Promedio:</div>
                    <div>0.6 </div>
                </div>

                <div class="d-flex justify-content-between">
                    <div> Gastos por animal:</div>
                    <div> 34,500</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div> Utilidad:</div>
                    <div>1,500</div>
                </div>
                  <div class="d-flex justify-content-between">
                    <div>Cantidad de animales vendidos</div>
                    <div>50</div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                    <b-button class="bg-primary">Ingresos</b-button>
                    <b-button class="bg-primary">Gastos</b-button>
                    <b-button class="bg-primary">Utilidad</b-button>
                </div>
                <div class="mt-1 notification">Notificaciones</div>
                <div class="mt-2 ml-3">
                    <div>Ganapp</div>
                    <div>Gasto mas significativo es el de  mano de obra.</div>
                </div>
                <div class="d-flex justify-content-center align-items-center mt-5">
                    <b-button class="bg-primary">Tabla de datos</b-button>
                </div>
            </b-form>
        </div>
        <ControlMenu />
    </div>

</template>


<script>
import ControlMenu from '@/components/ControlMenu.vue'
import { BFormGroup, BForm, BButton} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
export default {
    components: {
        ControlMenu,
        BFormGroup,
        BForm,
        flatPickr,
        BButton,
    },
    data() {
        return {
            date: null,
            dateDefault: null,
            timePicker: null,
            dateNtim: null,
            multiDate: null,
            rangeDate: null,
            humanDate: null,
            disableDate: null,
            inlineDate: null,
        }
    },
}
</script>


<style lang="scss">
.economicTitle {
    font-weight: 600;
    font-size: 24px;
}

.notification {
    font-weight: 500;
    font-size: 18px;
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>